<template>
    <div id="desktop-viewport">
        <div class="navbar">
            <WebLogo device="desktop" />
            <ControlPanel />
        </div>

        <!-- 【修改】加入 v-show 判斷，只有在不是 large 模式時才顯示主題頁籤。
             另外，站點只有一個主題時（中大白色能源屋）整條列都不顯示——
             一個點不下去的孤零零頁籤只是佔位置。用 v-if 而非 v-show，
             否則外層仍會留下它的下方間距。 -->
        <div
            v-if="showThemeNavigator"
            class="navigator-wrapper"
            v-show="largeCardId === 'None'"
        >
            <ThemeNavigator v-model="currentTheme" @meteor-click="scrollToMeteor" />
        </div>

        <div class="main-content">
            <Content :activeTheme="currentTheme" />

            <!-- 原本的 meteor-section 已經被移除了，保持乾淨 -->
        </div>

        <Footer device="desktop" />

        <!-- <transition name="slide-up">
            <div v-if="showMeteorPopup" class="meteor-popup" @click="scrollToMeteor">
                <div class="popup-icon">🌠</div>
                <div class="popup-text">
                    <strong>發現流星！</strong>
                    <span>剛剛捕捉到一張新的流星影像，點擊查看。</span>
                </div>
                <button class="close-btn" @click.stop="showMeteorPopup = false">✖</button>
            </div>
        </transition> -->
    </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue' // 【修改】補上 watch
import { useStore } from 'vuex'
import WebLogo from '@/components/common/WebLogo.vue'
import ControlPanel from '@/components/desktop/ControlPanel.vue'
import ThemeNavigator from '@/components/desktop/ThemeNavigator.vue'
import Content from '@/components/desktop/Content.vue'
import Footer from '@/components/common/Footer.vue'
import { resolveDefaultTheme } from '@/constants'
import { getAvailableThemes } from '@/themes'

const store = useStore()
const largeCardId = computed(() => store.state.largeCardId)

// 只有一個主題可選時不必顯示頁籤列
const showThemeNavigator = computed(
    () => getAvailableThemes(store.state.selectedStation).length > 1
)

const currentTheme = ref(resolveDefaultTheme(store.state.selectedStation))
const showMeteorPopup = ref(false)

// 【核心新增】監聽站點的變化，只要切換站點就回到該站的預設主題。
// 學校站點是「全部總覽」；中大白色能源屋沒有總覽，直接落在微電網，
// 否則會停在一個空白的總覽頁。
watch(
    () => store.state.selectedStation,
    (station) => {
        currentTheme.value = resolveDefaultTheme(station)
    }
)

onMounted(() => {
    setTimeout(() => {
        showMeteorPopup.value = true
    }, 3000)
})

const scrollToMeteor = () => {
    // 走既有的 largeCardId 放大機制：自動隱藏上方選擇欄、X 也能正確返回總覽
    showMeteorPopup.value = false
    store.commit('setLargeCardId', 'meteor')
}
</script>

<style lang="scss" scoped>
/* DesktopViewport.vue */
#desktop-viewport {
    height: 100vh; /* <-- 把 min-height 改成嚴格的 height: 100vh */
    overflow: hidden; /* <-- 新增這行：強制隱藏最外層捲軸，不准整個網頁往下滾 */
    width: 100vw;
    display: flex;
    flex-direction: column;
    background-image: linear-gradient(rgba(245, 245, 245, 0.5), rgba(245, 245, 245, 0.5)),
        url('~@/assets/background/bg-paper01.png');
    background-size: cover;
    background-attachment: fixed;
}

.navbar {
    height: 18vh; /* <-- 建議從 20vh 微調到 18vh，把空間讓一點給下方的卡片 */
    width: 100vw;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    flex-shrink: 0;
}

.main-content {
    flex-grow: 1; /* <-- 這行很重要，它會自動把 Navbar、頁籤、Footer 剩下的空間全部吃掉 */
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden; /* <-- 新增這行：確保內容不會溢出 */
    /* padding-bottom: 60px; <-- 刪除這行！這會製造不必要的底部空白，把 Footer 擠下去 */
}
.carousel-wrapper {
    width: 100%;
    max-width: 1200px;
    margin-top: 40px;
    padding: 0 20px;
}
.carousel-title {
    text-align: center;
    color: #4a5568;
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 16px;
    letter-spacing: 0.05em;
}

/* =========================================
   流星 Popup (Toast) 的樣式
========================================= */
.meteor-popup {
    position: fixed;
    bottom: 40px;
    right: 40px;
    background: rgba(15, 23, 42, 0.85); /* 深藍黑色底，帶點科技感 */
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: white;
    padding: 16px 20px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    z-index: 9999; /* 確保浮在最上層 */
    transition: transform 0.2s;

    &:hover {
        transform: translateY(-5px);
        background: rgba(15, 23, 42, 0.95);
    }

    .popup-icon {
        font-size: 2rem;
    }

    .popup-text {
        display: flex;
        flex-direction: column;
        gap: 4px;

        strong {
            font-size: 1.1rem;
            color: #fbbf24; /* 星星的黃色 */
            letter-spacing: 0.05em;
        }

        span {
            font-size: 0.9rem;
            color: #cbd5e1;
        }
    }

    .close-btn {
        background: none;
        border: none;
        color: #94a3b8;
        font-size: 1.2rem;
        cursor: pointer;
        padding: 4px;
        margin-left: 8px;

        &:hover {
            color: white;
        }
    }
}

/* 【新增】頁籤區塊的外層容器 */
.navigator-wrapper {
    position: relative; /* 建立絕對定位的參考點 */
    width: 100vw;
    display: flex;
    justify-content: center; /* 讓內部的 ThemeNavigator 依然完美置中 */
    align-items: center;
    /* 取代掉 ThemeNavigator 裡面的 margin-bottom，統一由外層控制間距 */
    margin-bottom: 10px;
}

/* Vue 的進場/退場動畫 */
.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}
.slide-up-enter-from,
.slide-up-leave-to {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
}
</style>
